export class ComplementoProjeto {

  idProjeto: number;
  codigoPrimeiroGrau: number;
  codigoSegundoGrau: number;
  codigoAtividadeEconomica: number;
  gerouPropriedadeIntelectual: boolean;
  possuiPublicacao: boolean;
  quantidadePublicacao: number;
  objetivo: string;
  etapa: string;
  resultadoObtido: string;

  constructor(init?: Partial<ComplementoProjeto>) {
    Object.assign(this, init);
  }
}
